import { EmeraldIcon } from "@emerald-react/icon";

type MediaItem = {
  mediaId: string;
  cloudfrontUrl?: string;
  displayName?: string;
  keyName?: string;
};

interface MediaLinksColumnProps {
  items: MediaItem[];
  isPreview: boolean;
  linkClass?: string;
  containerClass?: string;
}

const MediaLinksColumn = ({
  items,
  isPreview,
  linkClass = "w-full flex items-center min-w-0 py-0.5 text-primary-light",
  containerClass = "px-2 min-w-0 text-tiny",
}: MediaLinksColumnProps) => {
  if (!items || items.length === 0) return <div className={containerClass} />;

  return (
    <div className={containerClass}>
      {items.map((f) => (
        <a
          key={f.mediaId}
          href={f.cloudfrontUrl}
          target="_blank"
          rel="noopener noreferrer"
          title={f.displayName || f.keyName || f.mediaId}
          className={linkClass}
        >
          <span className="truncate min-w-0 underline">
            {f.displayName || f.keyName || f.mediaId}
          </span>
          {isPreview ? (
            <EmeraldIcon
              icon="open_in_new"
              type="filled"
              variant="icon"
              className="open-in-new-icon"
            />
          ) : null}
        </a>
      ))}
    </div>
  );
};

export default MediaLinksColumn;
